module.exports = __webpack_public_path__ + "img/itunes-note.da131685.svg";